var _path, _path2, _path3, _path4, _path5, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBunkeringManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 45,
    viewBox: "0 0 48 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 6.5C37 4.1 35.6667 3.5 35 3.5H22V9L25 15V20L19 27V42C24.6 44.8 30 41.8333 32 40L34.5 37.5C34.5 37.8333 35 38.6 37 39C39 39.4 39.8333 37.5 40 36.5H46.5V28H40C39.6667 28 39 27.6 39 26C39 24.4 35.6667 24.6667 34 25L30.5 20C31 19.5 32 18.3 32 17.5C32 16.5 31 15 29 15C29 11 32.3333 9.33333 34 9C35 8.83333 37 8.1 37 6.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 25L18 20H30L34.5 26V38.5L32 39.6915C30 44 18 44 16 39.6915L14 38.5V25Z",
    stroke: "#0957C2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 28L39.5 27C39.5 25.6193 38.3807 24.5 37 24.5V24.5C35.6193 24.5 34.5 25.6193 34.5 27L34.5 37C34.5 38.3807 35.6193 39.5 37 39.5V39.5C38.3807 39.5 39.5 38.3807 39.5 37L39.5 36.5M39.5 28L46 28M39.5 28L39.5 36.5M39.5 36.5L46 36.5",
    stroke: "#3F4C5F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4998 15H19.4998C18.1191 15 16.9998 16.1193 16.9998 17.5V17.5C16.9998 18.8807 18.1191 20 19.4998 20H29.4998C30.8806 20 31.9998 18.8807 31.9998 17.5V17.5C31.9998 16.1193 30.8806 15 29.4998 15H28.9998M20.4998 15C20.4998 12 18.0002 8.5 15.0002 8.5M20.4998 15L28.9998 15M28.9998 15C28.9998 12 32.5002 8.5 34.5 8.5",
    stroke: "#0957C2",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 36L9 37C9 38.3807 10.1193 39.5 11.5 39.5V39.5C12.8807 39.5 14 38.3807 14 37L14 27C14 25.6193 12.8807 24.5 11.5 24.5V24.5C10.1193 24.5 9 25.6193 9 27L9 28M9 36L2 36M9 36L9 28M9 28L2 28",
    stroke: "#3F4C5F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 3.5,
    width: 24,
    height: 5,
    rx: 2.5,
    stroke: "#0957C2",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBunkeringManagement);
export default __webpack_public_path__ + "static/media/icon-bunkering-management.a9e5a9afc7288e0b59628ebbb6bc17ba.svg";
export { ForwardRef as ReactComponent };